import { connect } from "react-redux";
import { PersonalDataPage } from "../screens/PersonalDataPage";
import { personalDataChangeTextField, personalDataPrivacyChange, personalDataPopupTextChange, personalDataPopupGenderChange, personalDataFormValidateAndSubmit, personalDataResetError, calculateFiscalCode } from "../reducers/personalDataForm";

function mapStateToProps(state) {
    const form = state.personalDataForm;
    const offer = state.offer;
    return {
        form, offer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        onChangeText: (name, value) => dispatch(personalDataChangeTextField(name, value)),
        onChangePrivacy: isPrivacyAccepted => dispatch(personalDataPrivacyChange(isPrivacyAccepted)),
        onChangeTextPopup: (name, value) => dispatch(personalDataPopupTextChange(name, value)),
        onChangeGender: isGenderMale => dispatch(personalDataPopupGenderChange(isGenderMale)),
        validateAndSend: () => dispatch(personalDataFormValidateAndSubmit()),
        resetError: name => dispatch(personalDataResetError(name)),
        calculateFiscalCode: () => dispatch(calculateFiscalCode())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDataPage);